import script from "./EditTaxAccount.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditTaxAccount.vue?vue&type=script&setup=true&lang=ts"

import "./EditTaxAccount.vue?vue&type=style&index=0&id=f42b93b4&lang=scss"

const __exports__ = script;

export default __exports__